import { render, staticRenderFns } from "./step-intro.vue?vue&type=template&id=22a06dc1"
import script from "./step-intro.vue?vue&type=script&lang=js"
export * from "./step-intro.vue?vue&type=script&lang=js"
import style0 from "./step-intro.vue?vue&type=style&index=0&id=22a06dc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports